import { I18NProxy } from './I18N'
import {
  DEFAULT_CULTURE,
  hasValidTextosBundle,
  resolveCulture,
} from '@utils/i18nLocale'
import { Store } from '@types'

export type TextosBundle = {
  idioma: Store['textos']['idioma']
  textos: Store['textos']['textos']
  resolvedCulture: string
}

export async function loadTextosBundle(
  requestedCulture?: string | number | null,
): Promise<TextosBundle> {
  const proxy = new I18NProxy()
  const culture = resolveCulture(requestedCulture)

  let data = (await proxy.loadIdioma(culture)) as {
    idioma?: Store['textos']['idioma']
    textos?: Store['textos']['textos']
  }

  if (!hasValidTextosBundle(data?.textos) && culture !== DEFAULT_CULTURE) {
    console.warn(`[i18n] Bundle "${culture}" inválido, fallback a ${DEFAULT_CULTURE}`)
    data = (await proxy.loadIdioma(DEFAULT_CULTURE)) as typeof data
  }

  const resolvedCulture = data?.idioma?.nombreCultura
    ? resolveCulture(data.idioma.nombreCultura)
    : culture

  return {
    idioma: data?.idioma ?? {
      id: 1,
      codigo: DEFAULT_CULTURE,
      nombreCultura: DEFAULT_CULTURE,
      idioma: 'Español',
    },
    textos: data?.textos ?? {},
    resolvedCulture,
  }
}
